import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import RseeReservationFactor from '../../reserves/modals/deprecated/rseeReservationFactor';
import UserSentFactorsFilter from './userSentFactorsFilter';

import * as invoicesActions from '../../../redux/invoices/actions';
import submitForm from '../../../utils/submitForm';
import generateClassName from '../../../utils/generateClassName';

class InvoicesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceOpen: false,
      selectedInvoiceId: null,
      status: '',
      sortType: 'asc',
      sortBy: 'startAt',
      selectedCafeName: '',
      query: '',
      filter: '',
      currentPage: 1,
      reservationFactorOpen: false,
      selectedReservationFactorId: -1,
      itemsPerPage: 10,
      isActive: false,
      sortedColumn: '',
    };
  }

  renderStatusColors = status => {
    switch (status) {
      case 'WAITING':
        return 'text-warning';
      case 'APPROVED':
        return 'text-success';
      case 'AUTO_APPROVED':
        return 'text-primary';
      case 'REJECTED':
        return 'text-danger';
      case 'STARTED':
        return 'text-info';
      case 'CLIENT_DO_NOT_CAME':
        return 'text-muted';
      case 'FINISHED':
        return 'text-secondary';
      default:
        return 'text-dark';
    }
  };

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.applysort(query);
  };

  applysort = query => {
    this.setState({ sortType: this.state.sortType === 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=startAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllUserInvoices(query);
    });
  };

  displayReservationFactorModal = id => {
    let { invoicesList = [] } = this.props;
    let selectedReservationFactor = invoicesList.filter(reserve => reserve.id == id)[0];
    this.setState({
      reservationFactorOpen: true,
      selectedReservationFactorId: selectedReservationFactor.reserveId,
      selectedCafeName: selectedReservationFactor.cafeName,
    });
  };

  closeReservationFactorModal = () => {
    this.setState(() => ({
      reservationFactorOpen: false,
    }));
  };

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      if (!this.state.query) {
        searchQuery = searchQuery.slice(0, -22);
      }
      this.props.fetchAllUserInvoices(searchQuery);
    });
  };

  render() {
    let {
      invoicesList = [],
      pageNumber,
      pageSize,

      invoicesLoading,
      invoicesMessage,
      invoicesError,
      invoicesFailed,
      invoices,
    } = this.props;
    let { totalRecords } = invoices;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        <Spin spinning={invoicesLoading}>
          {invoicesError && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {invoicesFailed && <div className="alert alert-danger">{invoicesMessage}</div>}
          <UserSentFactorsFilter applyFilters={this.applyFilters} filterAndSort={this.filterAndSort}/>
          <table className="table table-hover table-light table-striped">
            <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th onClick={() => this.sortTable('cafeName')} className="text-center pointer">
                <i
                  name="cafeName"
                  className={generateClassName('cafeName', this.state.sortedColumn, sortType)}
                />
                {locales('fields.cafe.name')}
              </th>
              <th onClick={() => this.sortTable('subTotalPrice')} className="text-center pointer">
                <i
                  name="subTotalPrice"
                  className={generateClassName('subTotalPrice', this.state.sortedColumn, sortType)}
                />
                {locales('tables.factorPrice')}
              </th>
              <th onClick={() => this.sortTable('totalPrice')} className="text-center pointer">
                <i
                  name="totalPrice"
                  className={generateClassName('totalPrice', this.state.sortedColumn, sortType)}
                />
                {locales('tables.payablePrice')}
              </th>
              <th onClick={() => this.sortTable('discountCode')} className="text-center pointer">
                <i
                  name="discountCode"
                  className={generateClassName('discountCode', this.state.sortedColumn, sortType)}
                />
                {locales('tables.discountValue')}
              </th>
              <th onClick={() => this.sortTable('reservedBaseCost')} className="text-center pointer">
                <i
                  name="reservedBaseCost"
                  className={generateClassName('reservedBaseCost', this.state.sortedColumn, sortType)}
                />
                {locales('tables.prePaid')}
              </th>
              <th onClick={() => this.sortTable('reservedAt')} className="text-center pointer">
                <i
                  name="reservedAt"
                  className={generateClassName('reservedAt', this.state.sortedColumn, sortType)}
                />
                {locales('titles.reservationDate')}
              </th>
              <th onClick={() => this.sortTable('persons')} className="text-center pointer">
                <i
                  name="persons"
                  className={generateClassName('persons', this.state.sortedColumn, sortType)}
                />
                {locales('tables.peopleCount')}
              </th>
              <th className="text-center"/>
            </tr>
            </thead>
            <tbody>
            {invoicesList.length ? (
              invoicesList.map((invoice, index) => (
                <tr key={invoice.id}>
                  <td className="text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td title={invoice.cafeName} className="text-center">
                    {invoice.cafeName}
                  </td>
                  <td className="text-center">{invoice.subTotalPrice.toLocaleString()}</td>
                  <td className={`text-center`}>{invoice.totalPrice.toLocaleString()}</td>
                  <td className={`text-center`}>{invoice.totalDiscountPercent}</td>
                  <td className={`text-center`}>{invoice.reservedBaseCost.toLocaleString()}</td>
                  <td className={`text-center`}>{invoice.reservedAt}</td>
                  <td className={`text-center`}>{invoice.persons}</td>
                  <td
                    title={locales('titles.seeFactorDetails')}
                    onClick={() => this.displayReservationFactorModal(invoice.id)}
                    className="text-center pointer"
                  >
                    <i className="text-center fal fa-receipt pointer"/>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
            </tbody>
          </table>
          <footer className="col-12 d-flex justify-content-center py-2">
            <div className="pagination-container">
              <Pagination2
                totalRecords={totalRecords || 0}
                pageLimit={itemsPerPage}
                pageNeighbours={2}
                onPageChanged={this.onPageChanged}
                currentPage={this.state.currentPage}
              />
            </div>
          </footer>
          {this.state.reservationFactorOpen && (
            <RseeReservationFactor
              reserveCafeName={this.state.selectedCafeName}
              isOpen={this.state.reservationFactorOpen}
              reservationId={this.state.selectedReservationFactorId}
              closeModal={this.closeReservationFactorModal}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    invoicesList: state.invoicesReducer.userInvoicesList,
    invoices: state.invoicesReducer.userInvoices,
    invoicesFailed: state.invoicesReducer.userInvoicesFailed,
    invoicesError: state.invoicesReducer.userInvoicesError,
    invoicesMessage: state.invoicesReducer.userInvoicesMessage,
    invoicesLoading: state.invoicesReducer.userInvoicesLoading,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchAllUserInvoices: query => dispatch(invoicesActions.fetchAllUserInvoices(props.userId, query)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InvoicesTable),
);
